import React, { Fragment, h} from "preact";
import {AppPage} from '../_common/components/app-page'
import {Card, CF, R} from '../_common/layout'
import {t} from '../_i18n'
import {useHistory} from 'react-router'
import {connect} from "react-redux";
import {useEffect, useState} from "preact/hooks";
import {Form as FinalForm} from "react-final-form"
import {Select, UploadFile, FormFieldSplittedDate} from "../_common/forms/components/components";
import ButtonSpinner from "../_common/components/buttons/buttonSpinner/buttonSpinner";
import Badge from "../_common/components/Badge";
import {getMadCertApplicationStatus, uploadMadCertPaymentReceipt} from "../_rx/mad-certificate-application/actions";

const STATUS_PENDING_APPLICATION = 1
const STATUS_VALIDATED = 2
const STATUS_UPLOADED_GITU = 3
const STATUS_VALIDATED_INSPECTION = 4
const STATUS_REJECTED = 5

const statusBadgeTextDic = {
    [STATUS_PENDING_APPLICATION]: t('Pendiente validación'),
    [STATUS_UPLOADED_GITU]: t('Validado'),
    [STATUS_VALIDATED_INSPECTION]: t('Validado'),
    [STATUS_VALIDATED]: t('Validado'),
    [STATUS_REJECTED]: t('Rechazado')
};
const statusBadgeClassDic = {
    [STATUS_PENDING_APPLICATION]: 'badge-warning',
    [STATUS_UPLOADED_GITU]: 'badge-success translucent',
    [STATUS_VALIDATED_INSPECTION]: 'badge-success translucent',
    [STATUS_VALIDATED]: 'badge-success translucent',
    [STATUS_REJECTED]: 'badge-danger'
};

const BadgeComponent = ({status, extraClass})=><Badge className={`t-upper width-fit-content badge font-small ${extraClass || ''} ${statusBadgeClassDic[status] || 'd-none'}`}>{t(statusBadgeTextDic[status])}</Badge>

function MadCertificateApplication({studentId, madCertificateApplicationStatus, enrolledAcademicPrograms, getMadCertApplicationStatus, uploadMadCertPaymentReceipt}) {
    const [file, setFile] = useState(null);
    const [fileURL, setFileURL] = useState('#');
    const [loading, setLoading] = useState(false);
    const academicPrograms = enrolledAcademicPrograms?.filter(ap => ap.formative_zone === 'MAD').map(ap => ({
        name: ap.title + ' ' +  `(${ap.formative_zone_code})`,
        key: ap.id
    }));
    const showMultipleCicles = academicPrograms.length > 1;
    const [academicProgramId, setAcademicProgramId] = useState(academicPrograms[0].key);

    useEffect(async () => {
        await getMadCertApplicationStatus(studentId);
    }, []);


    const handleUploadFile = async (event) => {
        let eventFile = event.target.files[0];
        setFile(eventFile);
        setFileURL(URL.createObjectURL(eventFile));
    }

    const handleRemoveFile = () => {
        setFile(null);
        setFileURL('#');
    }

    const handleSubmitFile = async (data) => {
        setLoading(true);
        await uploadMadCertPaymentReceipt(studentId, file, academicProgramId, data.payed_at);
        await getMadCertApplicationStatus(studentId);
        handleRemoveFile();
        setLoading(false);
    }

    const handleAPSelect = (e) => {
        if (e.target.value) setAcademicProgramId(e.target.value);
    }

    const renderRequestCard = (request) => {
        const academicProgram = request.academic_program_translation || enrolledAcademicPrograms.find(ap => ap.academic_program_id)?.title;
        return (
            <Card smOnly={false} className={'m-x2-bottom'}>
                <p className={'font-bold m-r'}>{academicProgram} </p>
                <BadgeComponent extraClass={!request.comments && 'm-bottom'} status={request.status_id} />
                {request.comments &&
                    <Fragment>
                        <p className={'font-color-soft-gray'}>{t('Comentarios')}</p>
                        <p>{request.comments}</p>
                    </Fragment>
                }
            </Card>
        )
    }

    return (
        <CF className="max-width-980 m-x2-top">
            <div dangerouslySetInnerHTML={{__html: t('mad_cert_application')}}/>
            {showMultipleCicles && (
                <fragment>
                    <div className='font-bold m-top-half'>{t('Selecciona el ciclo')}:</div>
                    <div className='m-top'>
                        <Select options={academicPrograms} value={academicProgramId} onChange={handleAPSelect} required/>
                    </div>
                </fragment>
            )}
            <div className='m-top'>
                <p className='font-bold m-bottom'>{t('Comprobante del pago de tasas del ministerio')}:</p>
                {!file ?
                    <div className='p-top'>
                        <UploadFile classNameButton='btn btn-ghost m-top m-bottom t-upper'
                                    accept='application/pdf,.docx,.doc,.odt' onChange={handleUploadFile}>
                            {t('Subir archivo')}
                        </UploadFile>
                        <span className='m-top font-color-879CA1'>{t('transfer_expedient_doc_types')}</span>
                    </div>
                    :
                    <div className='m-bottom d-flex flex-column sm-no-flex-column'>
                        <a className='m-r font-color-149BAB m-bottom sm-no-m-bottom' href={fileURL}
                           download={file.name}>{file.name}</a>
                        <span className='cursor-pointer font-color-soft-gray t-underline'
                              onClick={handleRemoveFile}>{t('Quitar archivo')}</span>
                    </div>
                }
            </div>

            <FinalForm
                onSubmit={handleSubmitFile}
                initialValues={{ payed_at: null }}
                validate={(values) => {
                    const errors = {};
                    if (!values.payed_at) {
                        errors.payed_at = t('Campo obligatorio');
                    }
                    return errors;
                }}
                render={({ handleSubmit, form }) => {
                    const { invalid, submitting } = form.getState();
                    return (
                        <Fragment>
                            <form id="payed-form" onSubmit={handleSubmit} noValidate>
                                <p className='font-bold mb-0'>{t('Fecha en la que se ha pagado la tasa:')}</p>
                                <R>
                                    <div className="col-100 md-col-60">
                                        <FormFieldSplittedDate name="payed_at" />
                                    </div>
                                </R>
                                <button type="submit" hidden />
                            </form>
                            <ButtonSpinner
                                showSpinner={loading}
                                disabled={!file || !academicProgramId || invalid || submitting}
                                onClick={() => document.getElementById('payed-form')?.requestSubmit()}
                            >
                                {t('Enviar solicitud')}
                            </ButtonSpinner>
                        </Fragment>
                    )
                }}
            />

            { madCertificateApplicationStatus && madCertificateApplicationStatus.length > 0 &&
                <h2 className='m-bottom m-top'>{t('Peticiones anteriores')}</h2>
            }

            { madCertificateApplicationStatus && madCertificateApplicationStatus.length > 0 &&
                madCertificateApplicationStatus.map(request => renderRequestCard(request))
            }
        </CF>
    )

}

MadCertificateApplication = connect(
    ({auth, madCertificateApplication, status}) => ({
        studentId: auth.loggedUser.id,
        madCertificateApplicationStatus: madCertificateApplication.status,
        enrolledAcademicPrograms: status.student_meta.enrolled_academic_programs
    }),
    {getMadCertApplicationStatus, uploadMadCertPaymentReceipt})(MadCertificateApplication);


export default () => {
    const history = useHistory();
    return (
        <AppPage
            name="mad-certificate-application"
            title={t('Solicitud de título')}
            back={history.goBack}
            class="max-width-980">
            <MadCertificateApplication/>
        </AppPage>
    );
}
